import { Injectable, OnDestroy } from "@angular/core";
import { Subject, fromEvent, Observable, interval, forkJoin } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { SystemService } from "../system/system.service";
import { share, takeUntil } from "rxjs";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { TranslateService } from "@root/shared/service/translate.service";

@Injectable({
  providedIn: "root",
})
export class IndexService {
  loadingRaw$ = new Subject<boolean>();
  networkRaw$ = new Subject<"on" | "off">();
  resizeRaw$ = new Subject();
  clickRaw$ = new Subject();

  scrollRaw$ = new Subject();
  taskRaw$ = new Subject<number>();
  destroy$ = new Subject();
  private timer;
  constructor(
    private httpServie: HttpClient,
    private t: TranslateService,
    private systemService: SystemService,
    private notify: NzNotificationService,
  ) {
    // this.initGlobalInfo();
  }

  displayLoading() {
    this.loadingRaw$.next(true);
  }

  dismissLoading() {
    this.loadingRaw$.next(false);
  }

  // initGlobalInfo() {
  //   console.log("start fetch global info ...");
  //   const source = forkJoin([
  //     this.systemService.syncFetchConfigInfo(),
  //     this.systemService.syncFetchConfigInfo()
  //   ]).subscribe(res => {
  //     console.log('fetch global info completed |> ', res);
  //   })
  // }

  /**
   * 这里存在一些不足
   * 当退出账号重新登录账号时，index组件会重新初始化，但是index.service不会销毁，会再次调用该方法，导致事件处理器被多次注册
   * 尽管在事件传递过程中相同的事件处理器被过滤掉了，但这仍然是一个不足的地方
   * 将index.service设置为组件服务可以解决该问题
   * TODO: enhancement
   */
  initDomEvents() {
    fromEvent(window, "offline").subscribe(() => this.networkRaw$.next("off"));

    fromEvent(window, "online").subscribe(() => this.networkRaw$.next("on"));

    fromEvent(window, "resize").subscribe(() => this.resizeRaw$.next(null));

    fromEvent(window, "click").subscribe(() => this.clickRaw$.next(null));
  }

  initVersionUpdateChecker() {
    Object.assign(window, {
      getVersion: (version) => {
        if (
          (localStorage.frontendVersion && version !== +localStorage.frontendVersion) ||
          (window["frontendVersion"] && version !== +window["frontendVersion"])
        ) {
          this.notify.blank(
            this.t.t("update-notification_title"),
            this.t.t("update-notification_content", { version }),
            {
              nzPlacement: "bottomRight",
              nzDuration: 0,
            },
          );
          // location.reload();
        }
        localStorage.frontendVersion = version;
        window["frontendVersion"] = version;
      },
    });
    let versionScript;
    this.timer = setInterval(() => {
      if (versionScript) {
        versionScript.parentNode.removeChild(versionScript);
      }
      versionScript = document.createElement("script");
      versionScript.src = location.origin + "/version.js?v=" + new Date().getTime();
      const s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(versionScript, s);
    }, 1000 * 60 * 1);
  }

  initTaskStatus() {
    // const map = {
    //   1: 'doing',
    //   2: 'success',
    //   3: 'fail'
    // };
    this.requestTaskStatus().subscribe((res) => {
      if (res.error_code === 0) {
        const data = res.data;
        this.taskRaw$.next(data.sync_status);
      }
    });
    // interval(10000)
    //   .pipe(mergeMap(_ => this.requestTaskStatus()))
    //   .subscribe(res => {
    //     if (res.error_code === 0) {
    //       const data = res.data;
    //       this.taskRaw$.next(map[data.sync_status]);
    //     }
    //     console.log('[polling]:', res);
    //   });
  }

  private requestTaskStatus() {
    const api = "/api/task/status";
    return this.httpServie.get(api) as Observable<any>;
  }

  destroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
}
